"use client";
import React, { useState } from "react";
import dayjs from "dayjs";
import { Space } from "antd";
import Title from "antd/lib/typography/Title";

import DateSelector from "@/app/components/DateSelector";

import SelectService from "../../../../components/SelectService";
import DisplaySchedules from "../DisplaySchedules";
import { UserData, ServiceOption, Service } from "@/lib/api/types";
import { formatDate, getDatesBetween } from "@/lib/helpers";
import { useApp } from "@/lib/hooks/useAppointment";
import { DB_DATE_FORMAT } from "@/consts";

interface StylistPageAppointmentProps {
  userId: string;
  name: string;
  userPathId: string;
  services: (Service & { option?: ServiceOption })[];
  schedules: UserData["schedules"];
  vacations: UserData["vacations"];
}
const StylistPageAppointment = ({
  userId,
  name,
  userPathId,
  services,
  schedules,
  vacations,
}: StylistPageAppointmentProps) => {
  const { date, setDate, openAppointmentForm } = useApp();
  const dateString = formatDate(date);
  const [refreshCount, setRefreshCount] = useState(0);
  const [selectedServices, setSelectedServices] = useState<
    (Service & { option?: ServiceOption })[]
  >(
    services[0]
      ? [
          {
            ...services[0],
          },
        ]
      : []
  );

  const workDays: number[] = [];
  schedules.forEach(({ hours }) => {
    hours.forEach((hour: string[], index: number) => {
      if (hour[2] === "on") {
        if (!workDays.includes(index)) {
          workDays.push(index);
        }
      }
    });
  });

  const convertedVacations = vacations
    ? vacations.flatMap((vacation) =>
        getDatesBetween(vacation.startDate, vacation.endDate)
      )
    : [];

  const isTodayOnVacation = convertedVacations.some(
    (_date) => dayjs(_date).format(DB_DATE_FORMAT) === dateString
  );

  const filteredWorkDays = [0, 1, 2, 3, 4, 5, 6].filter(
    (day) => !workDays.includes(day)
  );

  return (
    <>
      {workDays.length !== 0 && (
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          <section aria-labelledby="appointment-section">
            <header>
              <Title level={5}>Appointment</Title>
            </header>
            <DateSelector
              selectedDate={date}
              setDate={setDate}
              filteredWorkDays={filteredWorkDays}
              excludedDates={convertedVacations}
              hasBorder={true}
            />
          </section>

          {services.length > 0 && (
            <section aria-labelledby="service-selection-section">
              <SelectService
                showPrice={true}
                defaultServices={services}
                selectedServices={selectedServices}
                setServices={(
                  services: (Service & { option?: ServiceOption })[]
                ) => setSelectedServices(services)}
              />
            </section>
          )}

          <section aria-labelledby="schedule-display-section">
            <DisplaySchedules
              userId={userId}
              userName={name}
              userPathId={userPathId}
              isTodayOnVacation={isTodayOnVacation}
              date={dateString}
              services={selectedServices}
              refreshCount={refreshCount}
              onTimeClick={openAppointmentForm}
              onRefresh={() => setRefreshCount(refreshCount + 1)}
            />
          </section>
        </Space>
      )}
    </>
  );
};

export default React.memo(StylistPageAppointment);
